module.exports = " <div class=wrap _v-98e5ca58=\"\"> <ul class=drop-list _v-98e5ca58=\"\"> <li class=drop v-for=\"drop in pageDrops\" v-link=\"{ name: 'drops', params: { title: drop.id + '.' + drop.title }}\" _v-98e5ca58=\"\"> {{fdrops.length - $index}}.{{drop.title}}<span _v-98e5ca58=\"\">{{drop.date}}</span> </li> </ul> <a class=loadmore @click=loadMore() _v-98e5ca58=\"\"> Load More </a> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/template-rewriter.js?id=_v-98e5ca58!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropList.vue
 ** module id = 27
 ** module chunks = 2
 **/